import { render, staticRenderFns } from "./TermOfService.vue?vue&type=template&id=ee560cd2&scoped=true&"
import script from "./TermOfService.vue?vue&type=script&lang=js&"
export * from "./TermOfService.vue?vue&type=script&lang=js&"
import style0 from "./TermOfService.vue?vue&type=style&index=0&id=ee560cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee560cd2",
  null
  
)

export default component.exports